const BUSINESS_CARD_ASPECT_HEIGHT = 0.57;

export { BUSINESS_CARD_ASPECT_HEIGHT };
